import makeStyles from "@mui/styles/makeStyles";
import { View } from "../../Base";

const useStyles = makeStyles({
  container: {
    margin: "20px 0px 0px 20px",
    display: "flex",
    gap: "10px",
  },
});

export const DriverManagementReloadContent = () => {
  const styles = useStyles();
  return (
    <View className={styles.container}>
      Are You sure you want to reload depot data? All unsaved changes will be
      lost.
    </View>
  );
};
